import { apiClient } from "./client";

function resource(path, { deletable = false } = {}) {
  const calls = {
    list: async (params) => (await apiClient.get(path, { params })).data,
    retrieve: async (id) => (await apiClient.get(`${path}${id}/`)).data,
    create: async (payload) => (await apiClient.post(path, payload)).data,
    update: async (id, payload) => (await apiClient.patch(`${path}${id}/`, payload)).data,
  };

  if (deletable) {
    calls.remove = async (id) => {
      await apiClient.delete(`${path}${id}/`);
    };
  }

  return calls;
}

export const adminAgenciesApi = resource("/agencies/", { deletable: true });
export const adminUsersApi = resource("/auth/users/", { deletable: true });

export const platformDashboardApi = {
  getMetrics: async ({ days = 7 } = {}) =>
    (await apiClient.get("/agencies/platform-dashboard/", { params: { days } })).data,
};
